const _adal = {
  isCallback: (hash) => {
    console.log('Mock isCallback called with hash:', hash);
    return false; // Always return false for mock
  },
  getCachedToken: () => {
    console.log('Mock getCachedToken called');
    return localStorage.getItem('mock-token'); // persist
  },
  getCachedUser: () => {
    console.log('Mock getCachedUser called');
if (!localStorage.getItem('mock-token')) return null;
    return {
      Id: 1, // Add a mock Id field
      userName: 'admin',
      profile: {
        roles: ['Admin'], // Simulate admin role
      },
    };
  },
  acquireToken: (resource, callback) => {
    console.log('Mock acquireToken called for resource:', resource);
    localStorage.setItem('mock-token', 'mock-token');
    callback(null, 'mock-token');
  },
  clearCache: () => {
localStorage.removeItem('mock-token');
    console.log('Mock clearCache called');
  },
  login: () => {
    console.log('Mock login called');
  },
  verbose: console.log,
  error: console.error,
  info: console.info,
  getRequestInfo: () => ({}),
  saveTokenFromHash: () => console.log('Mock saveTokenFromHash called'),
  getLoginError: () => null,
  getResourceForEndpoint: (url) => {
    console.log('Mock getResourceForEndpoint called with URL:', url);
    // Return a mock resource for the given URL
    return 'mock-resource';
  },
  _getItem: (key) => {
    console.log(`Mock _getItem called with key: ${key}`);
    // const mockStorage = {
    //   'mock-key': 'mock-value',
    //   'adal.error.description': 'mock-error-description',
    //   'adal.start.page': '/mock-start-page',
    // };
    // return mockStorage[key] || null;
    return null; // Simulate no stored items
  },
  CONSTANTS: {
    STORAGE: {
      ERROR_DESCRIPTION: 'mock-error-description',
      START_PAGE: 'mock-start-page',
    },
  },
  config: {
    loginResource: 'mock-login-resource',
  },
  _callBackMappedToRenewStates: {},
  _renewActive: false, // Add this property to simulate token renewal state
};

module.exports = _adal;


// WEBPACK FOOTER //
// ./adal/adal-mock.js